module.exports = __webpack_public_path__ + "img/graduation-hat-02.54e542c2.svg";